import { Link } from "react-router-dom"
import "./AboutContentStyles.css"

import React from 'react'

import Perfil from "../assets/perfil.png"
import IntroImg from "../assets/background/mulher-jovem-com-problemas-nas-costas-fazendo-tratamento-de-fisioterapia.jpg"
import { FaAlignCenter, FaUserGraduate, FaUserMd } from "react-icons/fa"
import { GoGoal } from "react-icons/go"
import { FaWhatsapp, FaPlus } from "react-icons/fa"


const AboutContent = () => {
    return (
        <section id="about">
            <div className="about">
                {/* <div className="about-mask">
                <img className="about-bkg-img" src={IntroImg} alt="IntroImg" />
            </div> */}

                <h1>Sobre mim</h1>

                <div className="content">
                    <p>
                        <FaUserMd size={40} style={{ marginRight: "1rem" }} color="#0c488d" />Olá! Sou <b>Ana Cláudia</b> e minha jornada pela profissão é baseada em reestabelecer o movimento, a saúde e qualidade de vida das pessoas.
                    </p>
                    <p>
                        <FaUserGraduate size={40} style={{ marginRight: "1rem" }} color="#0c488d" /> Formada em Fisioterapia pela <b>UFU - Universidade Federal de Uberlândia</b>.
                    </p>
                    <p>
                        <FaPlus size={40} style={{ marginRight: "1rem" }} color="#0c488d" /> Especialização em <b>Traumato-Ortopédica e Esportiva</b> pela Faculdade Inspirar.
                    </p>
                    <p>
                        <GoGoal size={40} style={{ marginRight: "1rem" }} color="#0c488d" /> Meu objetivo é atuar tanto na prevenção de lesões quanto no reestabelecimento dos movimentos, melhorando a capacidade funcional do indivíduo,
                        que consequentemente retorna às suas atividades de vida diária. A prática baseada em evidências está presente em todos os atendimentos,
                        juntamente com ética, respeito, empatia e comprometimento.
                    </p>
                    <div className="agendar">
                        <a href="https://api.whatsapp.com/send/?phone=5534998680500&text=Ol%C3%A1!%20Quero%20agendar%20uma%20avalia%C3%A7%C3%A3o,%20voc%C3%AA%20pode%20me%20passar%20mais%20informa%C3%A7%C3%B5es?" key="WhatsApp" target="_blank" rel="noopener noreferrer" underline="none">
                            <button className="btn"><FaWhatsapp size={20} style={{ marginRight: "1rem" }} />Agendar avaliação!</button>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default AboutContent